import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
	title: 'title'               the name show in submenu and breadcrumb (recommend set)
	icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
	{ path: '/login', component: () => import('@/views/login/index'), hidden: true },
	{ path: '/404', component: () => import('@/views/404'), hidden: true },
	{
		path: '',
		component: Layout,
		redirect: '/home',
		children: [{
			path: 'home',
			name: 'home',
			component: () => import('@/views/home/index'),
			meta: { title: '首页', icon: 'home' }
		}]
	}
]

export const asyncRouterMap = [
	{
		path: '/cs',
		component: Layout,
		redirect: '/cs/consumer',
		name: 'cs',
		meta: { title: '顾客管理', icon: 'consumer' },
		children: [
			{
				path: 'consumer',
				name: 'consumer',
				component: () => import('@/views/cs/consumer/List'),
				meta: { title: '顾客档案', icon: 'consumer-list' }
			}
		]
	},
	{
		path: '/gm',
		component: Layout,
		name: 'gm',
		meta: { title: '商品管理', icon: 'goods' },
		children: [
			{
				path: 'goods',
				name: 'goods',
				component: () => import('@/views/gm/goods/List'),
				meta: { title: '商品列表', icon: 'goods-list' }
			},
			{
				path: 'auto-purchase',
				name: 'auto-purchase',
				component: () => import('@/views/gm/auto-purchase/Index'),
				meta: { title: '自动采购下单' },
				props: route => ({ isEdit: route.query.isEdit, isView: route.query.isView, goodsId: route.query.goodsId })
			},
			{
				path: 'order-failed',
				name: 'order-failed',
				component: () => import('@/views/gm/order-failed/orderFailed'),
				meta: { title: '自动下单失败', icon: 'order-list' }
			}
		]
	},
	{
		path: '/oms',
		component: Layout,
		redirect: '/oms/order',
		name: 'oms',
		meta: { title: '订单', icon: 'order' },
		children: [
			{
				path: 'order',
				name: 'order',
				component: () => import('@/views/oms/order/index'),
				meta: { title: '订单列表', icon: 'product-list' }
			},
			{
				path: 'shopee-order',
				name: 'shopee-order',
				component: () => import('@/views/oms/shopee-order/index'),
				meta: { title: 'Shopee订单列表', icon: 'order-list' }
			},
			{
				path: 'problem-order',
				name: 'problem-order',
				component: () => import('@/views/oms/problem-order/Index'),
				meta: { title: '问题单列表', icon: 'product-list' }
			},
			{
				path: 'return-order',
				name: 'return-order',
				component: () => import('@/views/oms/return-order/List'),
				meta: { title: '退货单列表', icon: 'order-list' }
			},
			{
				path: 'return-instock',
				name: 'return-instock',
				component: () => import('@/views/oms/return-instock/List'),
				meta: { title: '泰国仓退货入库列表', icon: 'order-list' }
			},
			{
				path: 'refund',
				name: 'refund',
				component: () => import('@/views/oms/refund/List'),
				meta: { title: '待退款列表', icon: 'order-list' }
			},
			{
				path: 'confirming',
				name: 'confirming',
				component: () => import('@/views/oms/confirming/List'),
				meta: { title: '待确认列表', icon: 'order-list' }
			}
		]
	},
	{
		path: '/sms',
		component: Layout,
		redirect: '/sms/forwarding-order',
		name: 'sms',
		meta: { title: '仓储管理', icon: 'order' },
		children: [
			{
				path: 'forwarding-order',
				name: 'forwarding-order',
				component: () => import('@/views/sms/forwarding-order/index'),
				meta: { title: '代发货订单', icon: 'product-list' }
			},
			{
				path: 'shopify-order',
				name: 'shopify-order',
				component: () => import('@/views/sms/shopify-order/index'),
				meta: { title: 'Shopify订单列表', icon: 'product-list' }
			},
			{
				path: 'th-forwarding-order',
				name: 'th-forwarding-order',
				component: () => import('@/views/sms/th-forwarding-order/index'),
				meta: { title: '泰国仓发货单列表', icon: 'product-list' }
			},
			{
				path: 'arrival-order',
				name: 'arrival-order',
				component: () => import('@/views/sms/arrival-order/index'),
				meta: { title: '到货单列表', icon: 'product-list' }
			},
			{
				path: 'transfer-order',
				name: 'transfer-order',
				component: () => import('@/views/sms/transfer-order/index'),
				meta: { title: '转运单列表', icon: 'product-list' }
			},
			{
				path: 'fast-check',
				name: 'fast-check',
				component: () => import('@/views/sms/arrival-order/fastCheck'),
				meta: { title: '快速验收', icon: 'product-list' }
			},
			{
				path: 'stock-balance',
				name: 'stock-balance',
				component: () => import('@/views/sms/stock-balance/list'),
				meta: { title: '库存看板', icon: 'product-list' }
			},
			{
				path: 'error-order',
				name: 'error-order',
				component: () => import('@/views/sms/error-order/index'),
				meta: { title: '到货单异常列表', icon: 'product-list' }
			},
			{
				path: 'war',
				name: 'war',
				component: () => import('@/views/sms/warOut/index'),
				meta: { title: '出库单', icon: 'product-list' }
			},
			{
				path: 'warup',
				name: 'warup',
				component: () => import('@/views/sms/warup/index'),
				meta: { title: '入库单', icon: 'product-list' }
			},
			{
				path: 'scanning',
				name: 'scanning',
				component: () => import('@/views/sms/scanning/scanning'),
				meta: { title: '包裹扫描签收', icon: 'product-list' }
			},
		]
	},
	{
		path: '/pcm',
		component: Layout,
		redirect: '/pcm/supplier',
		name: 'pcm',
		meta: { title: '采购', icon: 'pcm' },
		children: [
			{
				path: 'supplier',
				name: 'supplier',
				component: () => import('@/views/pcm/supplier/list'),
				meta: { title: '供应商管理' }
			},
			{
				path: 'plan',
				name: 'plan',
				component: () => import('@/views/pcm/plan/list'),
				meta: { title: '采购计划列表' }
			},
			{
				path: 'purchase',
				name: 'purchase',
				component: () => import('@/views/pcm/purchase/list'),
				meta: { title: '采购需求列表' }
			},
			{
				path: 'purdemand',
				name: 'myPurDemand',
				component: () => import('@/views/pcm/purdemand/list'),
				meta: { title: '我的待采购' }
			},
			{
				path: 'order',
				name: 'purchaseOrder',
				component: () => import('@/views/pcm/order/list'),
				meta: { title: '采购单' }
			},
			{
				path: 'unable-purchase',
				name: 'unable-purchase',
				component: () => import('@/views/pcm/unable-purchase/index'),
				meta: { title: '无法采购' }
			}
		]
	},
	{
		path: '/scm',
		component: Layout,
		name: 'scm',
		meta: { title: '供应链', icon: 'order' },
		children: [
			{
				path: 'material-stock-up',
				name: 'material-stock-up',
				component: () => import('@/views/report/scm/material-stock-up'),
				meta: { title: '辅料备货助手', icon: 'report' }
			},
			{
				path: 'stock-in',
				name: 'stock-in',
				component: () => import('@/views/report/scm/stock-in'),
				meta: { title: '成品入库报表', icon: 'report' }
			},
			{
				path: 'delivery-report',
				name: 'delivery-report',
				component: () => import('@/views/report/scm/delivery'),
				meta: { title: '发货报表', icon: 'report' }
			},
			{
				path: 'transit-report',
				name: 'transit-report',
				component: () => import('@/views/report/scm/transit'),
				meta: { title: '生产在途报表', icon: 'report' }
			},
			{
				path: 'purchasing',
				name: 'purchasing',
				component: () => import('@/views/scm/purchasing/List'),
				meta: { title: '采购统计' }
			},
			{
				path: 'quality',
				name: 'quality',
				component: () => import('@/views/scm/quality/List'),
				meta: { title: '质检统计' }
			},
			{
				path: 'delivery',
				name: 'delivery',
				component: () => import('@/views/scm/delivery/List'),
				meta: { title: '发货统计' }
			},
			{
				path: 'sales-report',
				name: 'sales-report',
				component: () => import('@/views/scm/sales-report/Index'),
				meta: { title: '销售日报表' }
			},
			{
				path: 'goods-sales-report',
				name: 'goods-sales-report',
				component: () => import('@/views/scm/goods-sales-report/Index'),
				meta: { title: '商品销售报表' }

			},
			{
				path: 'receivable',
				name: 'receivable',
				component: () => import('@/views/scm/receivable/Index'),
				meta: { title: '应收款报表' }
			},
			{
				path: 'overall',
				name: 'overall',
				component: () => import('@/views/scm/overall/Index'),
				meta: { title: '供应链整体概览' }
			}
		]
	},
	{
		path: '/scm-report',
		component: Layout,
		name: 'scm-report',
		meta: { title: '采购追踪报表', icon: 'total-week' },
		children: [
			{
				path: 'purchase-report',
				name: 'purchase-report',
				component: () => import('@/views/scm/purchase-report/List'),
				meta: { title: '采购付款追踪' }
			},
			{
				path: 'purchased-detail',
				name: 'purchased-detail',
				component: () => import('@/views/scm/purchased-detail/List'),
				meta: { title: '已采购sku明细列表' }
			},
			{
				path: 'stocked-detail',
				name: 'stocked-detail',
				component: () => import('@/views/scm/stocked-detail/List'),
				meta: { title: '已入库sku明细列表' }
			},
			{
				path: 'un-stock',
				name: 'un-stock',
				component: () => import('@/views/scm/un-stock/List'),
				meta: { title: 'sku未入库明细列表' }
			}
		]
	},
	{
		path: '/image',
		component: Layout,
		name: 'image',
		meta: { title: '图片素材管理', icon: 'sms-ad' },
		children: [
			{
				path: 'upload',
				name: 'upload',
				component: () => import('@/views/image/upload/Index'),
				meta: { title: '图片素材管理', icon: 'sms-ad' }
			}
		]
	},
	// {
	// 	path: '/ad',
	// 	component: Layout,
	// 	name: 'ad',
	// 	meta: { title: '广告素材', icon: 'sms-ad' },
	// 	children: [
	// 		{
	// 			path: 'ad-generate',
	// 			name: 'ad-generate',
	// 			component: () => import('@/views/ad/ad-generate/Index'),
	// 			meta: { title: '广告素材生成', icon: 'sms-ad' }
	// 		}
	// 	]
	// },
	{
		path: '/ums',
		component: Layout,
		redirect: '/ums/admin',
		name: 'ums',
		meta: { title: '权限', icon: 'ums' },
		children: [
			{
				path: 'admin',
				name: 'admin',
				component: () => import('@/views/ums/admin/index'),
				meta: { title: '用户列表', icon: 'ums-admin' }
			},
			{
				path: 'role',
				name: 'role',
				component: () => import('@/views/ums/role/index'),
				meta: { title: '角色列表', icon: 'ums-role' }
			},
			{
				path: 'allocMenu',
				name: 'allocMenu',
				component: () => import('@/views/ums/role/allocMenu'),
				meta: { title: '分配菜单' },
				hidden: true
			},
			{
				path: 'allocResource',
				name: 'allocResource',
				component: () => import('@/views/ums/role/allocResource'),
				meta: { title: '分配资源' },
				hidden: true
			},
			{
				path: 'menu',
				name: 'menu',
				component: () => import('@/views/ums/menu/index'),
				meta: { title: '菜单列表', icon: 'ums-menu' }
			},
			{
				path: 'addMenu',
				name: 'addMenu',
				component: () => import('@/views/ums/menu/add'),
				meta: { title: '添加菜单' },
				hidden: true
			},
			{
				path: 'updateMenu',
				name: 'updateMenu',
				component: () => import('@/views/ums/menu/update'),
				meta: { title: '修改菜单' },
				hidden: true
			},
			{
				path: 'resource',
				name: 'resource',
				component: () => import('@/views/ums/resource/index'),
				meta: { title: '资源列表', icon: 'ums-resource' }
			},
			{
				path: 'resourceCategory',
				name: 'resourceCategory',
				component: () => import('@/views/ums/resource/categoryList'),
				meta: { title: '资源分类' },
				hidden: true
			}
		]
	},
	{
		path: '/report',
		component: Layout,
		name: 'report',
		meta: { title: '报表', icon: 'report' },
		children: [
			{
				path: 'goods-report',
				name: 'goods-report',
				component: () => import('@/views/report/goods/index'),
				meta: { title: '商品整体数据报表', icon: 'report' }
			},
			{
				path: 'all-sales-report',
				name: 'all-sales-report',
				component: () => import('@/views/report/sales/index'),
				meta: { title: '整体销售报表', icon: 'report' }
			},
			{
				path: 'goods-sales',
				name: 'goods-sales',
				component: () => import('@/views/report/goods-sales/index'),
				meta: { title: '商品销售报表', icon: 'report' }
			},
			{
				path: 'runtime-report',
				name: 'runtime-report',
				component: () => import('@/views/report/runtime/index'),
				meta: { title: '实时销售报表', icon: 'report' }
			},
			{
				path: 'order-report',
				name: 'order-report',
				component: () => import('@/views/report/order/index'),
				meta: { title: '订单销售柱状图', icon: 'report' }
			},
			{
				path: 'shopee-order-report',
				name: 'shopee-order-report',
				component: () => import('@/views/report/shopee/index'),
				meta: { title: 'shopee店铺数据统计报表', icon: 'report' }
			},
			{
				path: 'to-b-sales-report',
				name: 'to-b-sales-report',
				component: () => import('@/views/report/to-b/sales'),
				meta: { title: '美国批发销售和库存报表', icon: 'report' }
			},
			{
				path: 'to-b-agency-report',
				name: 'to-b-agency-report',
				component: () => import('@/views/report/to-b/dashboard'),
				meta: { title: '美国批发数据大盘', icon: 'report' }
			},
			{
				path: 'to-b-detail-report',
				name: 'to-b-detail-report',
				component: () => import('@/views/report/to-b/detail'),
				meta: { title: '订单明细', icon: 'report' }
			},
			{
				path: 'to-b-detail-stock',
				name: 'to-b-detail-stock',
				component: () => import('@/views/report/to-b/stock'),
				meta: { title: '库存明细', icon: 'report' }
			},
			{
				path: 'to-b-month-state',
				name: 'to-b-month-state',
				component: () => import('@/views/report/to-b/month/state'),
				meta: { title: '州业绩明细', icon: 'report' }
			},
			{
				path: 'to-b-month-salesman',
				name: 'to-b-month-salesman',
				component: () => import('@/views/report/to-b/month/salesman'),
				meta: { title: '销售代表业绩明细', icon: 'report' }
			},
			{
				path: 'to-b-month-rep',
				name: 'to-b-month-rep',
				component: () => import('@/views/report/to-b/month/rep'),
				meta: { title: '代理商业绩明细', icon: 'report' }
			},
			{
				path: 'to-b-buyer',
				name: 'to-b-buyer',
				component: () => import('@/views/report/to-b/buyer'),
				meta: { title: '顾客订单明细', icon: 'report' }
			},
			{
				path: 'to-b-month-buyer',
				name: 'to-b-month-buyer',
				component: () => import('@/views/report/to-b/month/buyer'),
				meta: { title: '顾客订单统计', icon: 'report' }
			},
		]
	},
	// {
	// 	path: '/sg',
	// 	component: Layout,
	// 	name: 'sg',
	// 	meta: { title: '运维管理', icon: 'sms-ad' },
	// 	children: [
	// 		{
	// 			path: 'sgo',
	// 			name: 'sgo',
	// 			component: () => import('@/views/sg/sgo/index'),
	// 			meta: { title: '闪购管理', icon: 'sms-ad' }
	// 		}
	// 	]
	// },
	// {
	// 	path: '/cod',
	// 	component: Layout,
	// 	name: 'cod',
	// 	meta: { title: '应收款', icon: 'sms-ad' },
	// 	children: [
	// 		{
	// 			path: 'cods',
	// 			name: 'cods',
	// 			component: () => import('@/views/cod/cods/index'),
	// 			meta: { title: 'COD应收款', icon: 'sms-ad' }
	// 		}
	// 	]
	// },
	// {
	// 	path: '/war',
	// 	component: Layout,
	// 	name: 'war',
	// 	meta: { title: '出库单管理', icon: 'sms-ad' },
	// 	children: [
	// 		{
	// 			path: 'warout',
	// 			name: 'warout',
	// 			component: () => import('@/views/warout/warOut/index'),
	// 			meta: { title: '出库单列表', icon: 'sms-ad' }
	// 		}
	// 	]
	// },
	{ path: '*', redirect: '/404', hidden: true }
]

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js